import React from "react";
import "./About.scss";

function About() {
  return (
    <div className="about-component">
      <p>
        “Sun King" is a visually stunning and immersive theatre experience that
        will transport audiences to ancient Egypt. Combining elements of drama,
        music, dance, and elaborate stage design, the production will showcase
        the story of the powerful Sun King and his journey through the Egyptian
        pantheon.
      </p>
      <p>
        The uniqueness of this play is its writing - as a ballad. The intent to
        stage this play is in its uniqueness of style (it’s a ballad) and the
        fact that it has never been produced in any part of the globe. There
        have been only 4 known ballads covering ancient history - Ramayana,
        Mahabharata, Iliad and Odyssey and Paradise lost. The Sun King could be
        comparable to these genres of ancient story telling and though not
        intended, could mimic a more modern Shakespearean format and style. The
        language is cryptic and has several layers of meaningfulness embedded
        within its rhyming versus and sentences.
      </p>
    </div>
  );
}


export default About;
